/*
 * ⚠️ [amended P5b] THE CLIENT MOVED TO `@pams/client-core/http`. THIS FILE IS THE DASHBOARD'S
 *  ONE INSTANCE OF IT.
 *
 * The envelope unwrapping, the `ApiError`, the single-flight refresh, the retry-once-on-401
 * and the no-retry allowlist all live in `packages/client-core/src/http/apiClient.ts` now,
 * because `pwa/` must not carry a second implementation of refresh rotation. Family reuse
 * detection is a control that only works if the client cooperates, and two clients drift.
 *
 * The module's public surface is UNCHANGED and that is deliberate: 38 files import
 * `@/lib/api`, 22 test files `vi.mock` this exact specifier, and `lib/api.test.ts` drives
 * the refresh behaviour through it. A facade is what let all of that stay untouched — which
 * is how the extraction was verified rather than asserted.
 */
import { createAuthClient } from '@pams/client-core/http';
import { apiBaseUrl } from './runtimeConfig';
import { dashboardTokenStore } from './tokenStore';

export { ApiError, type ApiErrorCode, type AuthLostReason } from '@pams/client-core/http';

/**
 * Token storage lives in `tokenStore.ts` — one file, with the reasoning and the key names.
 * See its header before changing anything about it.
 */
export { clearTokens, getAccessToken, getRefreshToken, setTokens } from './tokenStore';

const client = createAuthClient({ baseUrl: apiBaseUrl, tokens: dashboardTokenStore });

export const api = client.api;

/** At most one `/auth/refresh` is ever in flight. See the factory for why that is load-bearing. */
export const refreshAccessToken = client.refreshAccessToken;

/**
 * Called when a refresh fails and the session is genuinely over. Set by AuthProvider —
 * this is how `lib/` tells React the user is signed out without importing React.
 */
export const setAuthFailureHandler = client.setAuthFailureHandler;
